module.exports = __webpack_public_path__ + "static/media/shape-thick.ce5ac52b.svg";